export default __webpack_public_path__ + "static/media/Outlook_128x128.3e76f608.webp";